import React from 'react';
import AdminResourceManagerPage from '../../components/admin/AdminResourceManagerPage';

export default function AdminStudentServicesPage() {
  return (
    <AdminResourceManagerPage
      moduleKey="studentServicesResources"
      title="Serviços ao Aluno"
      description="Atualize os atalhos, portais e documentos exibidos em Serviços ao Aluno."
      createLabel="Novo serviço ou documento"
      emptyMessage="Nenhum serviço cadastrado."
      supportsTag
      tagLabel="Descrição do card"
      tagHelperText="Texto exibido abaixo do título do card."
    />
  );
}
